module.exports = __webpack_public_path__ + "img/productThree.0a2141f1.png";